// TokenUsageCard.tsx
import React from "react";
import styles from "./TokenUsageCard.module.css";

interface TokenUsage {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
    prompt_tokens_details?: Record<string, number>;
    completion_tokens_details?: Record<string, number>;
}

interface Props {
    usage: TokenUsage;
}

export const TokenUsageCard: React.FC<Props> = ({ usage }) => {
    return (
        <div className={styles.card}>
            <div className={styles.section}>
                <strong>Total tokens:</strong> {usage.total_tokens}
            </div>

            <div className={styles.section}>
                <strong>Prompt tokens:</strong> {usage.prompt_tokens}
                {usage.prompt_tokens_details && (
                    <ul className={styles.detailList}>
                        {Object.entries(usage.prompt_tokens_details).map(([key, value]) => (
                            <li key={key}>
                                {key}: {value}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div className={styles.section}>
                <strong>Completion tokens:</strong> {usage.completion_tokens}
                {usage.completion_tokens_details && (
                    <ul className={styles.detailList}>
                        {Object.entries(usage.completion_tokens_details).map(([key, value]) => (
                            <li key={key}>
                                {key}: {value}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};
